<template>
  <div>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";

  export default {
    name: 'CustomerFinancingListComponent',
    data() {
      return {
        transactionStatus: this.$route.query['fi.transactionStatus'],
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '贷款用途',
            field: 'fi__intendeUse'
          },
          {
            name: '贷款金额(元)',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }

          },
          {
            name: '贷款利率(%)',
            field: 'fi__interestRate',
            formatter: function (r,c,v) {
              return v +'% (' +  Status2CN(r.fi__interestType)+')'
            }
          },
          {
            name: '贷款时间',
            field: 'fi__transactionDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '贷款状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
              return v== 'Processing' && ( moment(r.fi__endDate).valueOf() < moment().valueOf() )? '已逾期' : Status2CN('Financing_'+ v)
            }
          },
          {
            name: '操作',
            opts:[
              {
                clickHandler: (index, row)=>{
                  this.$router.push({
                    name: 'ServiceAdminFinancingDetail',
                    query: {
                      'fi.transactionId' : row.fi__transactionId
                    }
                  })
                },
                class: 'el-icon-info',
                name: '查看'
              },
            ]
          }
        ],
        payTransactionId: '',
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        filters: {
          form: {
            fi__transactionStatus: '',
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            fi__transactionDate: [],
            ct__productName: '',
            overdue: false
          },
          columns: [
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '贷款用途',
              component: 'el-input',
              field: 'fi__intendedUse'
            },
            {
              label: '贷款申请日',
              component: 'date-range-picker',
              field: 'fi__transactionDate'
            },
            {
              label: '状态',
              component: 'el-select',
              field: 'fi__transactionStatus',
              options: [
                {
                  label: '全部',
                  value: ''
                },
                {
                  label: '待放款',
                  value: 'Ready'
                },
                {
                  label: '放款中',
                  value: 'Paying'
                },
                {
                  label: '还款中',
                  value: 'Processing'
                },
                {
                  label: '已还清',
                  value: 'Settled'
                }
              ],
              op: 'eq',
              span: 8
            },
            {
              label: '已逾期',
              component: 'el-checkbox',
              field: 'overdue',
              span: 4
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerFinancingList()
          }
        }
      }
    },
    props: {
      customerId: {
        type: String
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.fi.customerId' : this.customerId,
            'xlist.search.fi.customerId.op' : 'eq',
            'xlist.search.fi.transactionStatus': this.$route.query['fi.transactionStatus'],
            'xlist.search.fi.transactionStatus.op': 'in',
            'xlist.sort.dataField': 'fi.transactionDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerFinancingList()
      }
    },
    mounted() {
      this.getCustomerFinancingList()
      this.getBankAccountList()
    },
    methods: {
      getCustomerFinancingList: function () {
        if(this.filters.form.overdue) {
          this.filters.form.fi__transactionStatus = 'Processing'
        }
        else {

        }
        xhr.getCustomerFinancingList(
          Object.assign(
            {},
            this.filterParams,
            xmlBuildQuery(this.filters),
            this.filters.form.overdue ? {
              'xlist.search.fi.endDate' : moment().format('YYYY-MM-DD'),
              'xlist.search.fi.endDate.dateformat': 'yyyy-MM-dd',
              'xlist.search.fi.endDate.op' : 'lt'
            } : {}
          ),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      },
      getBankAccountList: function () {
        xhr.getBankAccountList({},res=>{
          try{
            if(res.data.status == 'success') {
              this.payAccountList = res.data.data||[]
            }
          }catch (e) {

          }
        })
      },
      getCustomerBankAccountList: function (customerId) {
        xhr.getCustomerBankAccountList({
            'c.customerId': customerId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.loanAccountList = res.data.data||[]
              }
            }catch (e) {

            }
          })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerFinancingListComponent.vue